import PropTypes from "prop-types"
import React from "react"

import { Title, Description } from "./components"

const TextBlock = ({ title, description, descriptionStyle }) => (
  <>
    <Title>{title}</Title>
    <Description {...descriptionStyle}>{description}</Description>
  </>
)

export default TextBlock

TextBlock.propTypes = {
  description: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  descriptionStyle: PropTypes.object,
  title: PropTypes.string,
}
